// Sostituire tutto il documento, dalla parte dell'EDITOR.
//
// Non basta cambiare lo stato React: `@uiw/react-codemirror` parcheggia gli
// aggiornamenti che arrivano dall'esterno finche' stai digitando (c'e' un
// fermo apposta, `typingLatch`), e li applica dopo. Misurato: dopo un
// «Applica» il documento restava com'era, mentre lo stato React era gia'
// cambiato. Quindi le modifiche programmatiche si dispatchano sulla view — che
// e' la copia autorevole — e lo stato React le riceve dal suo `onChange`.

import { EditorView } from "@codemirror/view";


export function sostituisciTutto(view: EditorView, testo: string): void
{
    if (view.state.doc.toString() === testo) { return; }

    // Il cursore si tiene dov'era: una sostituzione totale, mappata, lo
    // spingerebbe in fondo al documento a ogni «Applica».
    const cursore = Math.min(view.state.selection.main.head, testo.length);

    view.dispatch({
        changes: { from: 0, to: view.state.doc.length, insert: testo },
        selection: { anchor: cursore },
    });
}


/** Porta il cursore a `pos`, lo mostra a meta' schermo e lascia il fuoco all'editor. */
export function vaiA(view: EditorView, pos: number): void
{
    view.dispatch({
        selection: { anchor: pos },
        effects: EditorView.scrollIntoView(pos, { y: "center" }),
    });

    view.focus();
}
